module.exports = __webpack_public_path__ + "img/brief_icon_renshen.55c4c3d2.png";